import { Badge } from "react-bootstrap";

type CounterProps = {
    counter: number;
    isWarning?: boolean;
    className?: string;
}

export const ZCounter = ({counter, isWarning, className}: CounterProps) => {
    return (
        <Badge className={`badge-info-lighten counter-badge ${className}`} bg={isWarning === true ? "warning" : "primary"}>{counter}</Badge>
    );
}